import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Lock, Mail, LogIn, GraduationCap } from "lucide-react";
import { adminLogin } from "./adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(email.trim(), password);
      navigate("/admin/notifications");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-vedanti-navy relative overflow-hidden px-4">
      <Helmet>
        <title>Admin Login | Vedanti Academy</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(249,115,22,0.25)_0%,_transparent_55%)]" />
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-vedanti-orange to-vedanti-mango mb-4">
            <GraduationCap className="text-white" size={28} />
          </div>
          <h1 className="font-heading text-2xl font-extrabold text-white">Vedanti Academy</h1>
          <p className="text-slate-400 text-sm mt-1">Admin Control Panel</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-2xl p-8 space-y-5"
          data-testid="admin-login-form"
        >
          {error && (
            <div className="bg-red-50 border border-red-100 text-red-700 text-sm rounded-lg px-4 py-2.5" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <div>
            <label className="block text-sm font-semibold text-vedanti-navy mb-1.5">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@vedantiacademy.com"
                className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-vedanti-orange/40 focus:border-vedanti-orange text-sm"
                data-testid="admin-login-email"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-vedanti-navy mb-1.5">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-vedanti-orange/40 focus:border-vedanti-orange text-sm"
                data-testid="admin-login-password"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-vedanti-orange hover:bg-orange-600 text-white font-bold py-2.5 rounded-lg transition-all disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            <LogIn size={16} /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
